import React from 'react';

import {
  TRANSACTION_BANK_FIELDS,
  TRANSACTION_EXPENSE_FIELDS,
} from './constants';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  TableCell,
} from '@material-ui/core';
import { Layout } from '../global/Table/TablePageHelpers/LayoutObject';
import TablePage from '../global/Table/TablePage';
import TwoStepDelete from '../global/subcomponents/twoStepDelete/TwoStepDelete';
import { FormControlLabel, Tooltip } from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import EditIcon from '@material-ui/icons/Edit';

class TransactionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteId: null,
      open: false,
      comment: '',
      isMobile: window.matchMedia('(max-width: 800px)').matches,
    };
  }

  getTableHeadersExpense = () => {
    let headers = [];
    TRANSACTION_EXPENSE_FIELDS.forEach((headCell) => {
      headers.push(
        Layout.columnHead(headCell.label, headCell.id, headCell.align)
      );
    });
    headers.push(Layout.columnHead(null, null));
    return headers;
  };

  getTableHeadersBank = () => {
    let headers = [];
    TRANSACTION_BANK_FIELDS.forEach((headCell) => {
      headers.push(
        Layout.columnHead(headCell.label, headCell.id, headCell.align)
      );
    });
    headers.push(Layout.columnHead(null, null));
    return headers;
  };

  handleClickOpen = (commentText) => {
    this.setState({
      open: true,
      comment: commentText,
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  tableRowExpense = (expense) => {
    return (
      <React.Fragment>
        {this.props.isToolbar === true && (
          <TableCell align="center" style={{ padding: '0.2rem' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.selectedEntries.includes(
                    expense.transactionId
                  )}
                  onChange={() =>
                    this.props.handleSelectTransaction(expense.transactionId)
                  }
                  style={{ marginTop: '8px', marginLeft: '8px' }}
                />
              }
            />
          </TableCell>
        )}

        {this.props.isToolbar === false && (
          <TableCell align="center" style={{ padding: '0.2rem' }}>
            {this.isEditAllowed(expense?.description) && (
              <IconButton onClick={() => this.props.handleEditRow(expense)}>
                <EditIcon fontSize="medium" />
              </IconButton>
            )}
          </TableCell>
        )}

        <TableCell
          className="table-cell-left"
          style={{
            whiteSpace: 'nowrap',
            fontSize: window.innerWidth <= 800 ? '13px' : 'inherit',
          }}
        >
          {expense?.dateTime}
        </TableCell>
        <TableCell className="table-cell-left">{expense?.amount} </TableCell>
        <TableCell className="table-cell-left">
          {expense?.description}
        </TableCell>
        <TableCell className="table-cell-left">
          {expense?.comments && (
            <Tooltip title={'Show Comment'}>
              <IconButton
                onClick={() => this.handleClickOpen(expense.comments)}
              >
                <CommentIcon fontSize="medium" />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>

        {this.isDeleteAllowed(expense?.description) ? (
          <TwoStepDelete
            rowId={expense?.transactionId}
            handleDelete={(rowIdToDelete) =>
              this.props.deleteTransaction({
                transactionId: expense?.transactionId,
              })
            }
            deleteId={this.state.deleteId}
            setDeleteId={(newDeleteId) =>
              this.setState({ deleteId: newDeleteId })
            }
          />
        ) : (
          <TableCell />
        )}
      </React.Fragment>
    );
  };

  tableRowBank = (bank) => {
    return (
      <React.Fragment>
        {this.props.isToolbar === true && (
          <TableCell align="center" style={{ padding: '0.2rem' }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.selectedEntries.includes(
                    bank.transactionId
                  )}
                  onChange={() =>
                    this.props.handleSelectTransaction(bank.transactionId)
                  }
                  style={{ marginTop: '8px', marginLeft: '8px' }}
                />
              }
            />
          </TableCell>
        )}

        {this.props.isToolbar === false && (
          <TableCell align="center" style={{ padding: '0.2rem' }}>
            {this.isEditAllowed(bank?.description) && (
              <IconButton onClick={() => this.props.handleEditRow(bank)}>
                <EditIcon fontSize="medium" />
              </IconButton>
            )}
          </TableCell>
        )}

        <TableCell
          className="table-cell-left"
          style={{
            whiteSpace: 'nowrap',
            fontSize: window.innerWidth <= 800 ? '13px' : 'inherit',
          }}
        >
          {bank?.dateTime}
        </TableCell>
        <TableCell className="table-cell-left">{bank?.amount} </TableCell>
        <TableCell className="table-cell-left">{bank?.description}</TableCell>
        <TableCell className="table-cell-left">
          {bank?.comments && (
            <Tooltip title={'Comments'}>
              <IconButton onClick={() => this.handleClickOpen(bank.comments)}>
                <CommentIcon fontSize="medium" />
              </IconButton>
            </Tooltip>
          )}
        </TableCell>
        {this.isDeleteAllowed(bank?.description) ? (
          <TwoStepDelete
            rowId={bank?.transactionId}
            handleDelete={(rowIdToDelete) =>
              this.props.deleteTransaction({
                transactionId: bank?.transactionId,
              })
            }
            deleteId={this.state.deleteId}
            setDeleteId={(newDeleteId) =>
              this.setState({ deleteId: newDeleteId })
            }
          />
        ) : (
          <TableCell />
        )}
      </React.Fragment>
    );
  };

  isEditAllowed = (description) => {
    const isRestrictedDescription = description?.includes('CASH LEFT');
    return !isRestrictedDescription;
  };

  isDeleteAllowed = (description) => {
    const hasAdminRole = this.props.user?.authority?.includes('ROLE_ADMIN');

    if (hasAdminRole) return true;

    const isRestrictedDescription = description?.includes('CASH LEFT');
    return !isRestrictedDescription;
  };

  render() {
    const { expenseList, bankList } = this.props;
    const { open, comment, isMobile } = this.state;
    let totals = { expensesTotal: 0, bankTotal: 0 };

    if (Array.isArray(expenseList) && expenseList.length > 0) {
      totals.expensesTotal = expenseList.reduce(
        (total, expense) => total + parseFloat(expense.amount),
        0
      );
    }

    if (Array.isArray(bankList) && bankList.length > 0) {
      totals.bankTotal = bankList.reduce(
        (total, bank) => total + parseFloat(bank.amount),
        0
      );
    }

    return (
      <>
        <Dialog open={open} onClose={this.handleClose}>
          <DialogTitle>Comment</DialogTitle>
          <DialogContent style={{ width: '400px', height: '100px' }}>
            <Divider style={{ marginBottom: '16px', marginTop: '-8px' }} />
            <p>{comment}</p>
          </DialogContent>
          <DialogActions>
            <Button
              style={{ marginRight: '24px', marginBottom: '16px' }}
              variant="contained"
              color="primary"
              onClick={this.handleClose}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <div
          className="rowSpecSuppliers"
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            width: '100%',
          }}
        >
          {/*<div className="rowSpecSuppliers">*/}
          {/*//this is for Bank*/}
          <div
            style={{
              width: isMobile ? '100%' : '50%',
              marginBottom: isMobile ? '24px' : '0',
            }}
          >
            <div
              style={{
                backgroundColor: '#6c93e9',
                color: 'black',
                padding: '16px',
                textAlign: 'center',
                fontWeight: 'bold',
                marginTop: '16px',
              }}
            >
              Bank Total: ({totals.bankTotal})
            </div>
            <div style={{}}>
              <TablePage
                tableName="bankTable"
                tableRows={bankList}
                tableColumnHeads={this.getTableHeadersBank()}
                tableRow={this.tableRowBank}
                paginationText="Results"
                defaultSortBy="dateTime"
              />
            </div>
          </div>

          {/*//this is for Expense*/}
          <div
            style={{
              width: isMobile ? '100%' : '50%',
              marginBottom: isMobile ? '16px' : '0px',
            }}
          >
            <div
              style={{
                backgroundColor: '#f4cc06',
                color: 'black',
                padding: '16px',
                textAlign: 'center',
                fontWeight: 'bold',
                marginTop: '16px',
              }}
            >
              Expenses Total: ({totals.expensesTotal})
            </div>
            <div
              style={{
                marginLeft: '-1px',
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
              }}
            >
              <TablePage
                tableName="expenseTable"
                tableRows={expenseList}
                tableColumnHeads={this.getTableHeadersExpense()}
                tableRow={this.tableRowExpense}
                paginationText="Results"
                defaultSortBy="dateTime"
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default TransactionTable;
